export const DownloadsState = _ => ({
  requests: [],
})
